import { Box } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { Loading } from '../components'
import { FirestoreContext } from '../providers/firestore-provider'
import { IStoreState } from '../store/types'

export const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const { username } = useContext(FirestoreContext)
  const loading = useSelector((state: IStoreState) => state.ui.loading)

  return (
    <Route
      {...rest}
      exact
      component={(props) => {
        if (loading) return <Loading />

        if (username)
          return (
            <Box pt={2} marginBottom={15}>
              <Container maxWidth="lg">
                <Component {...props} />
              </Container>
            </Box>
          )

        return <Redirect to={'/'}></Redirect>
      }}
    />
  )
}
